import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — decor: a fish tank (0.8 x 0.35 x 0.5 m) on a matte-black
// stand cabinet, ~1.1 m total. The tank reads from the front: a glass-tone
// body, a darker water surface on top, a gravel strip and two orange fish
// blocks proud of the front face.
const STAND = "#2e2e30";
const GLASS = "#9fc4d4";
const WATER = "#6f9db0";
const GRAVEL = "#8a7a62";
const FISH = "#c77b3a";

export const aquarium = defineModel({
  id: "aquarium",
  batchId: "modern",
  name: "Aquarium",
  tags: ["modern", "interior", "decor", "aquarium", "pet", "living-room"],
  summary: "A fish tank on a matte-black stand cabinet.",
  tiles: { w: 1, h: 1 },
  footprint: 0.8,
  parts(): Part[] {
    return [
      // stand cabinet
      { geometry: new THREE.BoxGeometry(0.84, 0.6, 0.4), color: STAND, position: [0, 0.3, 0] },
      // glass tank body
      { geometry: new THREE.BoxGeometry(0.8, 0.5, 0.35), color: GLASS, position: [0, 0.85, 0] },
      // darker water surface, sitting proud of the tank top so it reads
      // from above without z-fighting the glass
      { geometry: new THREE.BoxGeometry(0.76, 0.02, 0.31), color: WATER, position: [0, 1.11, 0] },
      // gravel strip along the front bottom of the tank
      { geometry: new THREE.BoxGeometry(0.76, 0.06, 0.02), color: GRAVEL, position: [0, 0.64, 0.18] },
      // two fish blocks proud of the front glass
      { geometry: new THREE.BoxGeometry(0.09, 0.04, 0.02), color: FISH, position: [-0.18, 0.88, 0.18] },
      { geometry: new THREE.BoxGeometry(0.07, 0.035, 0.02), color: FISH, position: [0.14, 0.98, 0.18] },
    ];
  },
  animations: [],
});
